import React ,{useState,useEffect}from 'react';
import axios from 'axios';
import { makeStyles} from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
import Sidebar from '../component/Sidebar';
import Bread from '../component/Breadcrumbs';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
// import MultiSelect from '../component/MultiSelect';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {AdminDetail as CountryList} from '../Services/AdminLogin';
import {AuthData} from '../Services/Authdata';
import useForm from './Auth/useForm';
import {UpdateDestinationValidation} from './Auth/UpdateValidation';
import {store} from '../Services/Destination';
import ImageUploader from 'react-images-upload';
import { useHistory, useParams} from "react-router-dom";


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  imagePreview:{
    marginTop:'10px',
    marginBottom:"10px"
  },
}));


export default function EditDestination(props) {
  //console.log(props.location.state.name);
    let { id } = useParams();
    const br = [{
      'title':'Trip',
      'icon':"",
      'url':'/trip'
    },{
      'title':'Edit Trip',
      'icon':"",
      'url':'/trip/edit/'+id
    }];
  let history = useHistory()
  const classes = useStyles();
  //const [file, setFile] = React.useState(props.location.state.name.image.replace(/[\[\]']+/g,'').replace(/['"]+/g, ''))
  const [file, setFile] = React.useState(null)
  const [clist, setClist] = useState([]);
  const [thumb, setThumb] = useState(null);
  const [pictures,setPictures] = useState([])
 
  const initialValues = {
	  name: props.location.state.name.name,
    nickname: props.location.state.name.nickname,
    about:props.location.state.name.about,
    image:props.location.state.name.image.replace(/[\[\]']+/g,'').replace(/['"]+/g, ''),
    thumbnail:props.location.state.name.thumbnail.replace(/[\[\]']+/g,'').replace(/['"]+/g, ''),
    country:props.location.state.name.country_id
  }
  const [defaultval,setDefaultval] = useState(initialValues); 
  const { values, errors, handleChange, handleSubmit } = useForm(initialValues,profile,UpdateDestinationValidation);
  useEffect(()=>{
    CountryList('countrylist','GET',AuthData().token).then((result)=>{
      const db = result.data.map((name) => (
        <MenuItem key={name.id} value={name.id}>{name.name_en}</MenuItem>
    ))
    setClist(db);
    })    
  },[])
  
  function profile(){

    //console.log(values);
    var fd = new FormData();
    fd.append('name',values.name);
    fd.append('nickname',values.nickname);
    fd.append('about',values.about);
    fd.append('country',values.country);
    if(thumb !=null){
      fd.append('thumbnail',thumb,thumb.name);
    }  
    if(file != null){
      fd.append('image',file,file.name);
    }

    axios.post(process.env.REACT_APP_BASEAPI_URL+"destination/edit/"+props.location.state.name.id,fd,{
      headers:{
        Authorization:'Bearer '+AuthData().token,
        //'Content-Type':'multipart/form-data'
      }
    }).then(res =>{
    if(res.data.status===1){
      history.push('/trip')
    }
    });


  }
  const fileHandler = (e) =>{
    setFile(e.target.files[0]);
    handleChange(e);
  }
  const thumbHandler = (e) =>{
    setThumb(e.target.files[0]);
    handleChange(e);
  }

  const onDrop = (picture) => {
    const e = {target:{
      type:"file",
      name:'image',
      files:picture
    }};
    handleChange(e);
    //console.log(picture[0]);
    setFile(picture[0]);
    //setPictures([...pictures, picture]);
    // console.log(pictures)
    setPictures(picture);
   // console.log(thumb.name);
      
  }
  const onDropThumb = (picture) => {
    setThumb(picture[0]);
   //console.log(thumb)
  } 

  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br} />
       <h1>Update Destinations</h1>
       
       <div>
        <form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={3}>
               <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <TextField
                  error={errors.name?true:false}
                  helpertext={errors.name}
                  id="name"
                  label="Name"
                  variant="outlined"
                  type="text"
                  name='name' 
                  size="small"
                  required
                  color="secondary"
                  onChange={handleChange}
                  defaultValue={props.location.state.name.name}
                  />
                </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <TextField 
                  error={errors.nickname?true:false}
                  helpertext={errors.nickname}
                  id="nickname"
                  label="Nickname"
                  variant="outlined"
                  type="text"
                  name='nickname' 
                  required
                  size="small"
                  color="secondary"
                  onChange={handleChange}
                  defaultValue={props.location.state.name.nickname}
                  />
                </FormControl>   

              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <TextField 
                  error={errors.about?true:false}
                  helpertext={errors.about}
                  multiline
                  rowsMax={4}
                  id="nickname"
                  label="About"
                  variant="outlined"
                  type="text"
                  name='about' 
                  required
                  size="small"
                  color="secondary"
                  onChange={handleChange}
                  defaultValue={props.location.state.name.about}
                  />
                </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
              <FormControl variant="outlined" style={{width:'100%'}}>
                <InputLabel id="demo-simple-select-outlined-label">Country</InputLabel>
                <Select
                error={errors.country?true:false}
                helpertext={errors.country}
                  labelId="demo-simple-select-outlined-label"
                  id="country"
                  label="country"
                  name='country'
                  defaultValue={props.location.state.name.country_id}
                  onChange={handleChange}
                >
                  {clist}
                </Select>
            </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                  style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                    <ImageUploader
                      withIcon={false}
                      name="image"
                      //defaultImages={[process.env.REACT_APP_AWS_URL+props.location.state.name.image.replace(/[\[\]']+/g,'').replace(/['"]+/g, '')]}
                      withPreview={true}
                      withLabel={false}
                      buttonText='Upload images'
                      onChange={onDrop}
                      imgExtension={['.jpg', '.gif', '.png', '.gif']}
                      maxFileSize={5242880}
                      singleImage={true}
                  />
                </FormControl>
                <span style={{color:"red"}}>{errors.image}</span>
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                  <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <ImageUploader
                    withIcon={false}
                    name="thumbnail"
                    withLabel={false}
                    //defaultImages={[process.env.REACT_APP_AWS_URL+props.location.state.name.image.replace(/[\[\]']+/g,'').replace(/['"]+/g, '')]}
                    withPreview={true}
                    buttonText='Upload Thumbnails'
                    onChange={onDropThumb}
                    imgExtension={['.jpg', '.gif', '.png', '.gif']}
                    maxFileSize={5242880}
                    singleImage={true}  
                  />
                  </FormControl>
                  <span style={{color:"red"}}>{errors.thumbnail}</span>
              </Grid>  
          </Grid>

          <FormControl style={{marginBottom:"5px"}}>
          <Button type="submit" variant="contained" color="primary" disableElevation>
          Save
          </Button>
          </FormControl>
        </form>
        
       </div>
      </main>
    </div>
    
   
  );
}


// WEBPACK FOOTER //
// ./src/Pages/EditDestination.js